import Vue from "vue";
import { tags , tagsArr } from "@/plugins/wApi/colors";

// console.log( Vue.prototype ) ; 
const { $wApi } = Vue.prototype ; 

const state = {
  tagAddPopWrapViewBln : false , // 공정도 신규 태그 추가 
  tagOptionPopListViewBln : false , // 태그 종류 목록 생성 
  tagOptionPopAddListViewBln : false , // 태그 검색/작성 팝업 생성 
  containerList : {} , 
  pos : { x : 0 , y : 0 } , 
  status : {
    type : '' , 
  } , 
  crntTag : {} , // 현재 열려있는 태그목록 명 
  crntList : [] , // 현태 열여있는 태그의 전체 목록 
  callbackFunc : null , 
  callbackFunc2 : null , 
} ; // end of state 

const mutations = {
  addTagPopContainerList ( state : any , { obj }) {
    let { containerList , containerListNew } = state ; 
    Object.assign( state.containerList , {
      ...containerList , 
      ...obj , 
    }) ; 
  } , 
  setTagAddPopWrapViewBln ( state : any , { bln }) {
    state.tagAddPopWrapViewBln = bln ; 
  } , 
  setTagOptionPopListViewBln ( state : any , { bln }) {
    state.tagOptionPopListViewBln = bln ; 
  } , 
  setTagOptionPopAddListViewBln ( state : any , { bln }) {
    state.tagOptionPopAddListViewBln = bln ; 
  } , 
  updatePos ( state : any , pos : any ) {
    Object.assign( state.pos , { ...pos }) ; 
  } , 
  setCrntTagType ( state : any , { tag }) {
    Object.assign( state.crntTag , { ...tag }) ; 
  } , 
  setCrntList ( state : any , { list }) {
    // console.log( 'list : ' , list ) ;  
    state.crntList = [] ; 
    list.map(( info : any , idx : number ) => {
      // console.log( info ) ; 
      Vue.set( state.crntList , idx , info ) ; 
    }) ; 
  } , 
  setCallbackFunc ( state : any , cb : any ) {
    state.callbackFunc = cb ; 
    Object.assign( state.crntTag , cb ) ; 
    Vue.set( state , 'callbackFunc' , cb ) ; 
  } , 
} ; // end of mutations 

const actions = {
  /* setCrntList ({ state } , { list }) {
    console.log( list ) ; 
    Object.assign( state.crntList , { ...list }) ; 
  } */
} ; // end of actions 

const getters = {
  tagAddPopWrapViewBln ( state : any ) {
    return state.tagAddPopWrapViewBln ; 
  } , 
  tagOptionPopListViewBln ( state : any ) {
    return state.tagOptionPopListViewBln ; 
  } , 
  tagOptionPopAddListViewBln ( state : any ) {
    return state.tagOptionPopAddListViewBln ; 
  } , 
  containerList ( state : any ) {
    return state.containerList ; 
  } , 
  pos ( state : any ) {
    return state.pos ; 
  } , 
  crntTag ( state : any ) {
    return state.crntTag ; 
  } , 
  crntList ( state : any ) {
    return state.crntList ; 
  } , 
  
  callbackFunc ( state : any ) {
    return state.callbackFunc ; 
  } , 
} ; // end of getters 

export default {
  namespaced: true,
  state ,
  mutations , 
  actions , 
  getters ,
} ; 